import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { FaSun, FaMoon } from 'react-icons/fa';

const ThemeToggle = () => {
  const { isDark, toggleThemeMode } = useTheme();

  return (
    <button
      onClick={toggleThemeMode}
      className="flex items-center gap-2 px-4 py-2 rounded-full font-semibold transition-all duration-300 hover:scale-105 bg-[var(--border)] text-[var(--text)] shadow-sm"
      aria-label="Toggle theme"
    >
      {isDark ? (
        <>
          <FaSun className="text-yellow-400 text-lg transition-transform duration-500 hover:rotate-180" />
          <span className="text-sm hidden sm:inline">Light</span>
        </>
      ) : (
        <>
          <FaMoon className="text-indigo-400 text-lg transition-transform duration-500 hover:rotate-180" />
          <span className="text-sm hidden sm:inline">Dark</span>
        </>
      )}
    </button>
  );
};

export default ThemeToggle;